import { Stack, Typography } from '@mui/material';
import EmptyData from '../../assets/images/empty-data-image.svg';

export const EmptyPage = () => {
  return (
    <Stack
      sx={{
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      <img
        src={EmptyData}
        alt="Empty Data"
        width={400}
        height={400}
      />
      <Typography variant='h5'>
        Data will show up here once customers and contracts are created
      </Typography>
    </Stack>
  );
};